
import React from 'react';
import { withRouter } from 'react-router-dom';
import SideBar from '../../components/modules/left_sidebar';
import NavBar from '../../components/common/navbar';
import Footer from '../../components/common/Footer';
import ReceitasEmCobranca from "../modules/rotulos/ReceitasEmCobranca";
import AgendaStatic from "../Agenda/agendastatic"
import TitleBar from "../../components/common/title_bar";
import MovsPendentes from "../../components/ContaModule/MovsPendentes"
import FiscPendentes from "../../components/ContaModule/FiscPendentes"
import MovsEmCurso from "../../components/ContaModule/MovsEmCurso"
import RotulosTables from "../modules/rotulos/RotulosTables"
import MarcasTable from "../modules/marcas/MarcasTable"
import SelosTables from "../modules/selos/SelosTable"
import SidePopup from "../modules/selos/SidePopup"
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import TransferenciasRotulos from '../modules/rotulos/TransferenciasRotulos';
import Main from '../Demo/main';
import ScheduleFilterComponent from '../../components/Schedule/schedule_filter_component';
import DashboardSchedule from '../../components/Schedule/dashboard_schedule_list';
import { Calendar } from 'antd';
import services from '../../services';
import TkCalender from '../../components/tlelrik/TkCalender';
import Lang from '../../lang'
const optionMenuArray =
{
    linkData: {
        tableName: "AgendaDigital",
        TitleBartitle: "AgendaDigital",
        prevPageName: "",
        prevPageLink: "",
        currentPath: "agenda_digital",
        TitleBarlogo: "agendadigital",
    }
}
const ScheduleCalenderdata = [{
    id: 0,
    title: "Holiday",
    start: new Date("2019-08-14T11:00:00Z"),
    end: new Date("2019-08-16T11:01:00Z"),
    isAllDay: false
}]

const columnkeyMap = {
    title: Lang.langCheck.langRequest("Title"),
    entity: Lang.langCheck.langRequest("Entity"),
    status: Lang.langCheck.langRequest("Status"),
    observation: Lang.langCheck.langRequest("Observation"),
    attendance: Lang.langCheck.langRequest("Attendance")
}
class AgendaDigitalPage extends React.Component {


    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod();
        this.state = {
            show: false,
            data: [],
            totalcount: '0',
            telkikTable: '',
            SortBy: 'ID',
            SortType: false,
            Paginate: false,
            Page: 1,
            PageSize: 10,
            show: false,
            calData: {}
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        console.log("agenda")
        this.setState(this.setLinkDataMethod());
        this.createpayload();
    }

/* Para tornar a classificação de tabelas dinâmica com api */

updatelistsort = (sort, key) => {
    this.setState({
        SortBy: key,
        SortType: sort
    }, () => this.createpayload())
}

/* Para tornar os dados da tabela dinâmicos com alterações de API */

updatelistpagenumsize(PageSize, page_num) {
    this.setState({
        Page: page_num,
        PageSize: PageSize
    }, () => this.createpayload());
}


/* Faça uma solicitação de filtro de API */

createpayload() {
    let data = {
        Filters: this.getFilters(),
        SortBy: this.state.SortBy,
        IsSortTypeDESC: this.state.SortType,
        IsPagination: this.state.Paginate,
        Page: this.state.Page,
        PageSize: this.state.PageSize
    };
    this.getList(data);
}

columnlist = Object.keys(columnkeyMap).map(function (key) {
    return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
});

/* Para carregar o componente da tabela e definir todas as colunas  */
createTabel = () => {
    let actionbuttons = { Edit: true, Redirect: true, Delete: true }
    //console.log("DATA",this.state.data);
    let telkikTable = <Main date={new Date()} deleteFunc={(id) => this.handleDelete(id)} list={this.state.data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action, id) => this.ActionPerform(action, id)} />
    this.setState({
        telkikTable: telkikTable
    })
}

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (prevProps) => {
        const parsed = this.props.location.state && this.props.location.state.paramoption || {};
        let prevParsed = prevProps.location.state && prevProps.location.state.paramoption || {}
        if (prevParsed.name !== parsed.name && (!parsed.tableName || parsed.back || this.state.search !== window.location.search || this.state.tableName !== parsed.tableName)) {
            this.setState(this.setLinkDataMethod())
        }
    }
    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */
    setLinkDataMethod = () => {
        let parsed = this.props.location.state && this.props.location.state.paramoption || {}
        if (Object.keys(parsed).length === 0 && this.state && this.state.parsed) {
            parsed = this.state.parsed
        }
        if (parsed.back) {
            parsed = {}
        }
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
        if (topBarMenu) {
            this.setState({ topBarMenu })
        }
        if (parsed) {
            this.setState({ parsed })
        }
        let selectOption = { ...optionMenuArray };
        let linkData = selectOption.linkData;
        if (!parsed.name) {
            linkData.prevPageName = "";
            linkData.prevPageLink = "";
            linkData.tableName = "agendadigital"
        }
        parsed.name = parsed.name ? parsed.name : ""
        parsed.url = parsed.url ? parsed.url : ""
        parsed.tableName = parsed.tableName ? parsed.tableName : ""
        if (parsed.name) {
            linkData.prevPageName = parsed.name;
            linkData.prevPageLink = parsed.url;
            linkData.tableName = parsed.tableName;
            linkData.prevPageName = parsed.name
        }

        return {
            noOption: true,
            popUpForm: null,
            linkData: linkData,
            parsed: parsed,
            tableName: linkData.tableName,
            TitleBartitle: "Instalações Vínicas",
            search: window.location.search,
            clickLimparFilter: false,
            noDownloadButton: true
        }
    }

    refreshComponent = () => {
        this.setState()
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerformRotulos = async (action, row) => {
        // console.log("action and row 333444555", action, row)
        let numeroAvalcao;
        if (action == 'Edit') {
            // this.props.history.push({
            //     pathname:`/create_schedule?id=${row.id}`
            // })
            //this.props.history.push({pathname : "/n_d_processo",search:'?from='+window.location.pathname.substr(1)+"&view=processo&id="+row.detalheURLID+"&correlativa="+row.detalheURLCorrelativa+"&codEstado="+row.detalheURLCodEstado})    
            this.props.history.push({pathname : "/n_d_processo",search:'?from='+window.location.pathname.substr(1)+"&view=processo&id="+row.detalheURLID+"&correlativa="+row.detalheURLCorrelativa+"&codEstado="+row.detalheURLCodEstado +"&idEntidade="+row.detalheURLIDEntidade + "&idRegistoProduto="+ row.idRegistoProdutoEncrypt})    
            //window.location = `/create_schedule?id=${row.id}`
            return;
        }
        if (action === 'Redirect') {
            // this.props.history.push({
            //     pathname:`/schedule_detail?id=${row.id}`
            // })
            window.location = `/schedule_detail?id=${row.id}`
        }
        if (action === 'Delete') {

        }
        if (action == 'GotoSchedule') {
            let params = new URLSearchParams(row.dataItem).toString();
            window.location = `/create_schedule?` + params
        }
        if (row.evaluationStatus === "pending") {
            numeroAvalcao = 0;
        }
        else if (row.evaluationStatus === "under_review1" || row.evaluationStatus === "review1_pending_2") {
            numeroAvalcao = 1;
        }
        else {
            numeroAvalcao = 2;
        }
        if (action === 'processOrder1') {
            this.checkUserPendingProcess(row);
            return;
        }
        else if (action === 'transferOrder') {

            return
        } else if (action === 'processOrder2') {

            this.props.history.push({
                pathname: "/n_d_processo",
                search: '?from=' + window.location.pathname.substr(1) + "&evaluator=" + numeroAvalcao + '&estado=' + row.estado + "&id=" + row.id + "&tdp=" + row.descricaos + "&processo=" + row["Nº Processo"] + "&marca=" + row.Marca
            })
            return
        } else if (action === 'ImagePreview') {


        }
        else if (action === "aprovados") {

            this.props.history.push({ pathname: "/n_d_processo", search: '?from=' + window.location.pathname.substr(1) + "&view=processo&id=" + row.id + '&estado=' + row.estado + "&tdp=" + row.Descrição + "&processo=" + row["Nº Processo"] + "&marca=" + row.Marca })
        }
        else {
            this.props.history.push({pathname : "/n_d_processo",search:'?from='+window.location.pathname.substr(1)+"&view=processo&id="+row.detalheURLID+"&correlativa="+row.detalheURLCorrelativa+"&codEstado="+row.detalheURLCodEstado +"&idEntidade="+row.detalheURLIDEntidade + "&idRegistoProduto="+ row.idRegistoProdutoEncrypt })      
            return;
        }
    }

    ActionPerformMarcas = (action, row) => {
        // console.log("xxxxxxxxxxxxx=========>", action, row);
        if (action === "pending") {
            this.props.history.push({
                pathname: "/marcas_n_d_processo",
                search: `?from=${window.location.pathname.substr(1)}&estado=${row.Estado
                    }&id=${row.idMarcaRequest}&tdp=Tipo de marca: ${row.tipoMarcaDetalhe
                    }&evaluator=1&processo=${row.idMarcaRequest}`,
            });
        } else if (action === "approved") {
            this.props.history.push({
                pathname: "/marcas_n_d_processo",
                search: `?from=${window.location.pathname.substr(1)}&estado=${row.Estado
                    }&id=${row.idMarcaRequest}&tdp=Tipo de marca: ${row.tipoMarcaDetalhe
                    }&evaluator=1&processo=${row.marca}`,
            });
        } else if (action === "history") {
            this.props.history.push({
                pathname: "/marcas_n_d_processo",
                search: `?from=${window.location.pathname.substr(1)}&estado=${row.Estado
                    }&id=${row.idMarcaRequest}&tdp=Tipo de marca: ${row.tipoMarcaDetalhe
                    }&processo=${row.marca}`,
            });
        }
    }
    getFilters() {
        return null;
    }

    handleFilter = (data) => {
        let actionbuttons = { Edit: true, Redirect: false, Delete: true }
        let telkikTable = <Main date={new Date()} deleteFunc={(id) => this.handleDelete(id)} list={data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action, id) => this.ActionPerform(action, id)} />
        this.setState({
            telkikTable
        })
    }

    /* Deletar linha da tabela de dados */

    handleDelete = (id) => {

    }

    /* Api chamando dados da tabela */

    getList = async (data) => {
        let _data = await services.apiCall.requestApi("schedule/GetAll", data, 'post')
        if (_data) {
            let monthData = _data;
            // _data.map((_r,i)=>{
            //     if(_r.date){
            //         monthData.push(_r)
            //     }
            // })

            // _data.map((_row,index)=>(
            //     Object.keys(columnkeyMap).map(function(key) {
            //       _row[columnkeyMap[key]] = _row[key]
            //     })
            //   ));

            this.setState({
                data: _data,
                calData: monthData,
                totalcount: window.localStorage.getItem('table_total')
            }, () => this.createTabel())
        }
    }

    /* Para mudança de status da página */

    handleShow = (status) => {
        this.setState({
            show: status
        })
    }
    ActionPerformSelos = (action, row) => {
        let menu = action.menu
        let submenu = action.submenu
        console.log("777000 menu ", menu, submenu, row)
        this.sidePopup(menu, submenu, row)
    };

    sidePopup = (menu, submenu, row) => {
        let header = {
            menu,
            submenu
        }

        let selosPopup = (
            <SidePopup
                date={Date.now()}
                header={header}
                row={row}
                closePopup={this.closePopup}
            />
        );
        this.setState({
            selosPopup,
        });
    };

    render() {
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu || this.state.topBarMenu
        return (
            <>
                <div className="dashboard">
                    <NavBar
                        date={new Date()}
                        linkData={this.state.linkData}
                        noOption={this.state.noOption}

                    />
                    <SideBar refreshComponent={() => this.refreshComponent()} />
                    <div className="inner-container agenda-background-logo pb-2">
                        <TitleBar
                            topBarMenu={this.props.topBarMenuOption}
                            title="Agenda Digital"
                            logo="agenda"
                            noOption={true}
                        />
                        <PanelBar expandMode="multiple">
                        <PanelBarItem title="Calendário">
                        <div className="row">
                           
                            <div className="col-md-12 pb-4 mb-4">
                                {
                                    // !this.state.show ?
                                    // <DashboardSchedule data={this.state} telkikTable={this.state.telkikTable} updatelistsort={(sort,columnkey)=>this.updatelistsort(sort,columnkey)} updatelistpagenumsize={(PageSize, page_num)=>this.updatelistpagenumsize(PageSize, page_num)} />
                                    // :
                                    this.state.calData.length > 0 &&
                                    <TkCalender data={this.state.calData} ActionPerform={(action, row) => this.ActionPerform(action, row)} />
                                }

                            </div>
                        </div>    
                        </PanelBarItem>
                        <PanelBarItem title="Fiscalização">
                                {/* <h4>Rótulos</h4>*/}
                                <FiscPendentes
                                    date={this.state.date}
                                    tableName="FiscPendentes"
                                    actionPerform={this.ActionPerformMarcas}
                                    applyedfilter={this.state.applyedfilter}
                                />
                            </PanelBarItem>
                            {/*<br />*/}
                            <PanelBarItem title="Marcas">
                                {/*<h4>Marcas</h4>*/}

                                <MarcasTable
                                    date={this.state.date}
                                    tableName="MarcasPendentes"
                                    actionPerform={this.ActionPerformMarcas}
                                    applyedfilter={this.state.applyedfilter}
                                />
                            </PanelBarItem>
                            {/*<br />*/}
                            <PanelBarItem title="Movimentos em Curso">
                                {/* <h4>Rótulos</h4>*/}
                                <MovsEmCurso
                                    date={this.state.date}
                                    tableName="MovsEmCurso"
                                    actionPerform={this.ActionPerformMarcas}
                                    applyedfilter={this.state.applyedfilter}
                                />
                            </PanelBarItem>
                            <PanelBarItem title="Movimentos Pendentes">
                                {/* <h4>Rótulos</h4>*/}
                                <MovsPendentes
                                    date={this.state.date}
                                    tableName="MovsPendentes"
                                    actionPerform={this.ActionPerformMarcas}
                                    applyedfilter={this.state.applyedfilter}
                                />
                            </PanelBarItem>
                            
                            
                            <PanelBarItem title="Rótulos">
                                {/* <h4>Rótulos</h4>*/}
                                <RotulosTables
                                    date={this.state.date}
                                    tableName="RotulosAgendaDigital"
                                    applyedfilter={this.state.applyedfilter}
                                    ActionPerform={(action, row) => this.ActionPerformRotulos(action, row)}
                                    title="Rótulos"
                                />
                            </PanelBarItem>
                            <PanelBarItem title="Transferências de Rótulos">
                                {/* <h4>Rótulos</h4>*/}
                                <TransferenciasRotulos
                                    date={this.state.date}
                                    tableName="TransferenciasRotulosTable"
                                    applyedfilter={this.state.applyedfilter}
                                    ActionPerform={(action, row) => this.ActionPerformRotulos(action, row)}
                                    title="Transferências de Rótulos"
                                />
                            </PanelBarItem>
                            <PanelBarItem title="Selos">
                                {/*<h4>Selos</h4>*/}
                                <SelosTables
                                    date={this.state.date}
                                    tableName="SelosPendentes"
                                    applyedfilter={this.state.applyedfilter}
                                    ActionPerform={(action, row) =>
                                        this.ActionPerformSelos(action, row)
                                    }
                                />
                            </PanelBarItem>
                        </PanelBar>


                    </div>
                    <Footer />
                   
                
                </div>
            </>
        );
    }
}

export default withRouter(AgendaDigitalPage);
